export default "__VITE_ASSET__DdUCI7f7__"